import React, { useCallback } from "react"
import * as AppConstants from "@/utility/AppConstants"
import "Css/table.css"
import { TableFieldsMultiAnno } from "@/utility/model"

function TabIndicatori(props: TableFieldsMultiAnno) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE
    
    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_INDICATORI_ELEM_AFF_RICAVI_COMPENSI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.punteggioIsaRicaviAdd
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.punteggioIsaRicaviAdd
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.punteggioIsaRicaviAdd
                        : elemNonDisponibile}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_INDICATORI_ELEM_AFF_AGGIUNTO_ADDETTO}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.punteggioIsaVaAdd
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.punteggioIsaVaAdd
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.punteggioIsaVaAdd
                        : elemNonDisponibile}
                </td>
            </tr>

            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_INDICATORI_ELEM_AFF_REDDITO_ADDETTO}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.punteggioIsaReddAdd
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.punteggioIsaReddAdd
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.punteggioIsaReddAdd
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_INDICATORI_ELEM_AFF_DECUMULO}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.punteggioDurataScorte
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {props.campo2 !== undefined
                            ? props.campo2.punteggioDurataScorte
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.punteggioDurataScorte
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_INDICATORI_ELEM_AFF_COMPLESSIVO}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.anomaliaInd
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {props.campo2 !== undefined
                            ? props.campo2.anomaliaInd
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.anomaliaInd
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
        </React.Fragment>
    )
}
export default TabIndicatori
